import { useEffect, useState } from "react";
import Papa from "papaparse";
import { v4 } from "uuid";

export const CSVTable = ({ csvString }: { csvString: string }) => {
  const [data, setData] = useState<Record<string, string>[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!csvString) {
      return;
    }
    Papa.parse(csvString, {
      header: true,
      skipEmptyLines: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      complete: (results: Papa.ParseResult<any>) => {
        if (results.errors.length) {
          setError(results.errors[0].message);
          setData([]);
          setHeaders([]);
        } else {
          setData(results.data);
          setHeaders(results.meta.fields || []);
          setError(null);
        }
      },
    });
  }, [csvString]);

  return (
    <div className="max-h-[45vh] max-w-[600px] overflow-auto rounded-lg border border-gray-200 bg-white shadow-sm">
      {error && (
        <div className="border-b border-red-200 bg-red-50 p-4 text-sm text-red-600">{error}</div>
      )}
      {data.length > 0 && (
        <table className="w-full text-sm">
          <thead className="border-b border-gray-200 bg-gray-50">
            <tr>
              {headers.map(header => (
                <th
                  key={header}
                  className="whitespace-nowrap px-4 py-3 text-left font-medium text-gray-900"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map(row => (
              <tr key={v4()} className="transition-colors hover:bg-gray-50">
                {headers.map(header => (
                  <td key={header} className="whitespace-nowrap px-4 py-3 text-gray-700">
                    {row[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
